// extracted by mini-css-extract-plugin
export default {"xs":"Text_xs__eC-rn","sm":"Text_sm__CrsqA","md":"Text_md__kuBAz","lg":"Text_lg__nB4N1","xl":"Text_xl__LV7DZ","xxl":"Text_xxl__WAFOr","xxxl":"Text_xxxl__Rv4zg"};